/** Roboto is registered per weight by `build-assets` (`shell-ui/fonts/Roboto-*.ttf`, family `Roboto`). */
export const SHELL_FONT_FAMILY = "Roboto, system-ui, sans-serif";

